import { useState, useEffect  } from 'react'
import { AccreditationEventIssuanceCriteriaFields } from '../partials/AccreditationEventIssuanceCriteriaFields'

const AccreditationEventIssuanceCriteria = props => {

  //console.log(props)
  const {
    value,
    contentChoices,
    scheduledTypesArgs,
    agencyId
  } = props

  const {ajax, ajaxConfig} = window.Tangible
  const [ certCustomFieldsRepeaterValue, setCertCustomFieldsRepeaterValue] = useState([])
  const [ pointTypes, setPointTypes ] = useState([])


  tangibleFields.event('valueChange', field => {
    if ( field.name === 'event_content_type' ){
      //console.log(field.value)
      //setEventContentType(field.value)
    }
    if ( field.name === 'event_certificate_template' ){
      setCertCustomFieldsRepeaterValue('[{"custom_field_name":"asdsadsa","custom_field_value":"qOOOOOqe"},{"key":"603f736c5e6560","custom_field_name":"BBBBB","custom_field_value":"CCCCC"}]')
    }
  })

  const store = tangibleFields.store;

  const fetchPointTypes = (agency_id) => {
    ajax('tgbl_get_point_types_terms', { agency_id} )
    .then( (res) => {
        if(res) {
          setPointTypes( res )
          store.setValue('event_issuance_criteria', store.getValue('event_issuance_criteria'));
        }
      }).catch(error => {
      console.error('TGBL Cred Ajax error', error)
    }).finally(() => {
      // setAjaxRetryDone(true)
    })
  }
  useEffect(() => {
    fetchPointTypes(agencyId)
  }, [agencyId])


  const [ accreditationFields, setAccreditationFields] = useState([])
  const getAccreditationFields = () => {
    ajax('tgbl_get_accreditation_fields_ajax', {agency_id: agencyId})
      .then( (res) => {
        setAccreditationFields(res)
        store.setValue('event_issuance_criteria', store.getValue('event_issuance_criteria'));
      }).catch(error => {
      console.warn(error);
    }).finally(() => {
      // setAjaxRetryDone(true)
    })
  }

  useEffect(()=>{
    setAccreditationFields([])
    getAccreditationFields(agencyId)
  },[agencyId])


  for(const item of value.accreditation_content_attributes ?? [] ) {
    if( typeof item.content_id === 'object' ) {
      continue;
    }
    let initData = window.tgblCredUI.contentAttributesInitData[item.content_id];
    //console.warn(item.content_id);

    item.content_id = { value: item.content_id, label: initData.contentName }
    item.earning_event = { value: item.earning_event, label: initData.eventName  }
  }

  const args = {
    value,
    accreditationFields,
    choices: contentChoices,
    pointTypes,
    certCustomFieldsRepeaterValue,
    scheduledTypesArgs
  }

  const eventIssuanceCriteria = tangibleFields.render({
    type: 'repeater',
    name: 'event_issuance_criteria',
    value: value.accreditation_content_attributes,
    layout: 'block',
    sectionTitle: '{{content_id.label}}',
    useSwitch: true,
    //dependent: true,
    fields: AccreditationEventIssuanceCriteriaFields(args),
    wrapper : {
     class: 'event-issuance-criteria-repeater'
    },
  })

  return (
    <div className="tf-issuance-schedules tgbl_accreditation_event_issuance">
      <div className="header__">
        <div className="tf-description">
        </div>
        { eventIssuanceCriteria }
      </div>
    </div>
  )
}

export { AccreditationEventIssuanceCriteria }
